import React, { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { onUpdateOrder } from "../graphql/mySubscriptions";
import ItemOrder from "../components/sendedOrders/itemOrder";
import useListSendedOrders from "../hooks/useListSendedOrders";
import "../../src/styles/style";
import { styleScreenDashboard } from "../../src/styles/style";
import ModalOrderDetails from "../components/modals/modalOrderDetails";
import ColumOptions from "../components/columnOptions/columnOptions";

const headers = [
  {
    title: "ID",
    tooltip: "ID de la orden",
  },
  {
    title: "Fecha y hora",
    tooltip: "Fecha y hora en la que se envió la orden a la tienda",
  },
  {
    title: "Tiempo de espera",
    tooltip:
      "Tiempo que ha transcurrido desde que se envió la orden, formato (DD:HH:MM:SS)",
  },
  {
    title: "Tienda",
    tooltip: "Nombre de la tienda a la cual se solicitó el pedido",
  },
  {
    title: "Ver",
    tooltip: "Muestra más detalles de la orden",
  },
  {
    title: "Insistir",
    tooltip:
      "Envia notificación al negocio, solo pueden enviarse cada 3 mins y un máximo de 3 recordatorios",
  },
];

const SendedOrders = ({ messageAssignOrder, optionSideBarSelected }) => {
  const { getSendedOrders } = useListSendedOrders();
  const [orders, setOrders] = useState([]);
  //? state to control the modal
  const [show, setShow] = useState(false);
  const [orderSelected, setOrderSelected] = useState({});

  useEffect(() => {
    //inicializamos valores
    initialSended();
    async function waitingUpdateOrder() {
      //console.log("Escuchando>");
      API.graphql({
        query: onUpdateOrder,
      }).subscribe({
        next: (messageData) => {
          setOrders([]);
          initialSended();
        },
      });
    }
    waitingUpdateOrder();
  }, []);

  const initialSended = async () => {
    var newOrders = await getSendedOrders();
    if (newOrders.length !== 0) setOrders(newOrders);
  };

  //? states to control the modal
  const handleClose = () => {
    setShow(false);
    setOrderSelected({});
  };
  const handleShow = () => setShow(true);

  //? selected order to see the details
  const selectOrder = (order) => {
    setOrderSelected(order);
    handleShow();
  };

  return (
    <div className="row">
      <div className="col-10">
        {orderSelected !== {} && show ? (
          <ModalOrderDetails
            orderInfo={orderSelected}
            show={show}
            handleClose={handleClose}
          />
        ) : null}
        <h1 style={{ textAlign: "center" }}>Ordenes sin atender</h1>

        {orders ? (
          <div
            //style={{ flexDirection: "column", display: "flex" }}
            //className="scroll"
            className="container"
            style={styleScreenDashboard.containerColumn}
          >
            <table className="table table-sm table-hover table-responsive ">
              <thead className="thead-dark">
                <tr>
                  {headers.map((item, x) => (
                    <th scope="col" className="text-center" key={x + "btn"}>
                      <button
                        type="button"
                        className="btn"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={item.tooltip}
                      >
                        {item.title}
                      </button>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {orders?.map((item, index) => (
                  <ItemOrder
                    key={item.id}
                    hour={item.updatedAt}
                    idOrder={item.id}
                    order={item}
                    messageAssignOrder={messageAssignOrder}
                    selectOrder={selectOrder}
                  />
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div>
            <h2>Vaya ... no hay ordenes enviadas que monitorear</h2>
          </div>
        )}
      </div>
      <ColumOptions onSelectOption={optionSideBarSelected} />
    </div>
  );
};

export default SendedOrders;
